import { CircularProgress, useTheme } from '@mui/material';
import { Theme } from '@mui/system';
import { makeStyles } from '@mui/styles';
import { useObjectSelector } from '@redux/store';
import { Grid } from '@ts/storybook';
import { FC } from 'react';

interface LoadingProps {
  inline?: boolean;
  loading?: boolean;
  size?: number;
}

const useStyles = makeStyles<Theme, { theme: Theme }>(() => ({
  gridCircular: props => ({
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 2000,
    backgroundColor: props.theme.palette.primary.main + '4a',
  }),
}));

const TLoading: FC<LoadingProps> = props => {
  const theme = useTheme();
  const className = useStyles({ theme });

  const { size, inline, loading: loadingProp } = props;
  const { loading } = useObjectSelector(state => state.request['global']);

  return (
    (loading || loadingProp) && (
      <Grid container justifyContent="center" alignItems="center" className={inline ? '' : className.gridCircular}>
        <CircularProgress size={size ?? 100} thickness={6} />
      </Grid>
    )
  );
};

export default TLoading;
